import { render, staticRenderFns } from "./LectureOrderDocs.vue?vue&type=template&id=2a17839c&scoped=true&"
import script from "./LectureOrderDocs.vue?vue&type=script&lang=js&"
export * from "./LectureOrderDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a17839c",
  null
  
)

export default component.exports